var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DialogTitle as MuiDialogTitle } from '@mui/material';
import classNames from 'classnames';
import styles from './DialogTitle.module.scss';
export function DialogTitle(_a) {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (_jsx(MuiDialogTitle, Object.assign({ className: classNames(className, styles['con-dialog-title'], styles['dialog-title-size']) }, props, { children: children })));
}
